// extracted by mini-css-extract-plugin
export default {"settings":"style_settings__zoFAd","header":"style_header__jAmk5","actions":"style_actions__Gnhf8"};